module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-32.7b0e5461.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-bonuses-32.png
// module id = 3185
// module chunks = 11